import { NpTestPlanGradeLevel } from './data/npTestPlanTypes'

export enum NpTestPlanSection {
  BUILD_PLAN = 'buildPlan',
  MANAGE_PLAN = 'managePlan',
  FEEDBACK_REPORT = 'feedbackReport',
}

export const NP_TEST_PLAN_SUPPORT_EMAIL = 'care@lyrahealth.com'

/**
 * The grades that are labelled by their number, so they can share one `select` message
 * instead of twelve near-identical ones. `NpTestPlanGradeLevel` names them `grade1`..`grade12`.
 */
export const NP_TEST_PLAN_NUMBERED_GRADES = Array.from({ length: 12 }, (_, index) => ({
  grade: index + 1,
  value: `grade${index + 1}` as NpTestPlanGradeLevel,
}))
